import EngineModule from '../EngineModule';
import {NS as PlannerWallsEditor} from '../components/viewer/planner/walls/Editor/PlannerWallsEditor';

export default () => EngineModule.all.find(x => x.id === 'viewer-planner-walls-editor') || new EngineModule.UIEngineModule({
	type: 'ui',
	useFullWidth : false,
	id: 'viewer-planner-walls-editor',
	dependencies: [
		'viewer-planner',
		'oms-basket'
	],
	allowedCustomers: null,
	modulesBefore: ['product-editor', 'viewer-planner-floor-editor'],
	modulesAfter: ['viewer-planner-furniture-editor'],
	usableCondition: {
		type: 'and',
		LHS: {
			type: 'notequal',
			component: 'K',
			property: 'TARGET.currentProduct',
			value: null
		},
		RHS: {
			type: 'or',
			LHS: {
				type: 'notequal',
				component: 'K.basket',
				property: '[*]TARGET.basket.currentProduct.hasPart(["layout"])',
				value: true
			},
			RHS: {
				type: 'notequal',
				component: 'K.basket',
				property: '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption',
				value: null
			}
		}
	},
	displayCondition: {
		type: 'and',
		LHS: {
			type: 'or',
			LHS: {
				type: 'and',
				LHS: {
					type: 'notequal',
					component: 'K.basket',
					property: 'TARGET.basket.currentProduct',
					value: null
				},
				RHS: {
					type: 'or',
					LHS: {
						type: 'notequal',
						component: 'K.basket',
						property: '[*]TARGET.basket.currentProduct.hasPart(["layout"])',
						value: true
					},
					RHS: {
						type: 'or',
						LHS: {
							type: 'equal',
							component: 'K.basket',
							property: '[*]TARGET.basket.currentProduct.getPartCurrentOptionMaybe(["layout"])',
							value: null
						},
						RHS: {
							type: 'and',
							LHS: {
								type: 'notequal',
								component: 'K.basket',
								property: '[*]TARGET.basket.currentProduct.getPartCurrentOptionMaybe(["layout"])',
								value: null
							},
							RHS: {
								type: 'notequal',
								component: 'K.basket',
								property: '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption.id',
								value: 'shape-no-wall'
							}
						}
					}
				}
			},
			RHS: {
				type: 'equal',
				component: 'K.basket',
				property: 'TARGET.basket.currentProduct',
				value: null
			}
		},
		RHS: {
			type: 'and',
			LHS: {
				type: 'notequal',
				component: 'K',
				property: 'TARGET.currentProduct',
				value: null
			},
			RHS: {
				type: 'or',
				LHS: {
					type: 'notequal',
					component: 'K.basket',
					property: '[*]TARGET.basket.currentProduct.hasPart(["layout"])',
					value: true
				},
				RHS: {
					type: 'and',
					LHS: {
						type: 'notequal',
						component: 'K',
						property: '[*]TARGET.currentProduct.getPart(["layout"]).currentOption',
						value: null
					},
					RHS: {
						type: 'notequal',
						component: 'K',
						property: '[*]TARGET.currentProduct.getPart(["layout"]).currentOption',
						value: 'shape-no-wall'
					}
				}
			}
		}
	},
	generateComponentConfiguration(): PlannerWallsEditor.Configuration {
		return {
			'@translations': this.translations,
			forceBackgroundColor: this.configuration.forceBackgroundColor ? this.configuration.forceBackgroundColor : null
		};
	}
});
